import { Fragment } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
// Models
import { IPage } from '@root/models/Page';
// Store
import { useAppDispatch, useAppSelector } from 'app/hooks/useStore';
// Reducers
import { PagesToolbarActions } from 'app/store/pagesToolbar/pagesToolbar.slice';
// Selectors
import { selectWorkspaceType } from 'app/store/ui/uiSelectors';
import { selectTrialMode } from 'app/store/AppUI/AppUI.selectors';
import { selectNewDesignEnabled, selectIsPageSelected } from 'app/store/pagesToolbar/pagesToolbar.selectors';
// Mui
import { Box, ToggleButton, Tooltip } from '@mui/material';
// Icons
import {
  CheckBox as CheckBoxIcon,
  CheckBoxOutlineBlank as CheckBoxOutlineBlankIcon
} from '@mui/icons-material';

type Props = {
  page: IPage;
}

const excludedPaths:string[] = [
  '/duplicates'
];
const includedPaths:string[] = [
  '/search'
];

const PageSelectButton = ({ page }:Props) => {
  const { t } = useTranslation();

  const { pathname } = useLocation();

  // Dispatch
  const dispatch = useAppDispatch();
  // State
  const trialMode = useAppSelector(selectTrialMode);
  const newDesignEnabled = useAppSelector(selectNewDesignEnabled);
  const isPageSelected = useAppSelector((state:any) => selectIsPageSelected(state, {
    documentId: page.documentId,
    pageNum: page.pageNum
  }));
  // ToDO
  const workspaceType = useAppSelector(selectWorkspaceType);

  const onTogglePageSelection = () => {
    const props = { documentId: page.documentId, pageNum: page.pageNum };
    if ( isPageSelected ) {
      dispatch(PagesToolbarActions.removeSelectedPage(props));
    } else {
      dispatch(PagesToolbarActions.addSelectedPage(props));
    }
  };

  const renderTitle = isPageSelected ? t('components.cardPage.unselectPage') : t('components.cardPage.selectPage');
  const renderIcon = isPageSelected ? <CheckBoxIcon /> : <CheckBoxOutlineBlankIcon />;

  const isPathExcluded = excludedPaths.some((path:string) => pathname.includes(path));
  const isPathIncluded = includedPaths.some((path:string) => pathname.includes(path));
  const isWorkspaceViewModeEpisodes = workspaceType === 'episodes';
  const isButtonHidden = trialMode || isWorkspaceViewModeEpisodes || (!newDesignEnabled && !isPathIncluded) || isPathExcluded;

  if ( isButtonHidden ) return null;
  return (
    <Fragment>
      <Box sx={{ flexGrow: 1 }} />
      <Tooltip title={renderTitle}>
        <ToggleButton
          sx={{ border: 'none', width: 34, height: 34 }}
          value="check"
          selected={isPageSelected}
          onClick={onTogglePageSelection}
          color="primary"
          size="small"
        >{renderIcon}</ToggleButton>
      </Tooltip>
    </Fragment>
  )
}

export default PageSelectButton;
